import { InputHTMLAttributes, DetailedHTMLProps } from "react";
interface ITimeInputOfficeHrs
  extends DetailedHTMLProps<
    InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  starttime: string | null;
  endtime: string | null;
  dayopen: string | null;
  label?: string;
  register: any;
  validation?: any;
  selectOnChange?: any;
  required?: boolean;
  requiredBorder?: string;
  startTimeonChange?: any;
  endTimeonChange?: any;
  name?: string;
  disabledStatus: boolean;
}
const TimeInputOfficeHrs: React.FC<ITimeInputOfficeHrs> = ({
  type = "time",
  register,
  validation,
  disabled = false,
  disabledStatus = false,
  selectOnChange,
  required,
  requiredBorder,
  startTimeonChange,
  endTimeonChange,
  name,
  ...props
}) => {
  return (
    <div className="space-y-1 w-full text-xs">
      <div className="grid grid-cols-1 md:grid-cols-3 w-full items-center gap-2">
        <label className="flex space-x-1 justify-start expandedLabel fontExpand">
          {props.label}:
        </label>
        <div className="col-span-2 grid grid-cols-1 md:grid-cols-3 gap-2 w-full">
          <div>
            {props.starttime === "mondayStartTime" && (
              <div className="text-center -mt-4">Start Time</div>
            )}
            <input
              className={`${disabled && "opacity-50"} ${
                requiredBorder ? requiredBorder : "border border-gray-300"
              } bg-clip-padding block w-full 
            px-1 py-1 text-xs sm:text-xs rounded-sm`}
              {...register(props.starttime, validation)}
              disabled={disabled}
              type={type}
              onChange={startTimeonChange}
              {...props}
            />
          </div>
          <div>
            {props.starttime === "mondayStartTime" && (
              <div className="text-center -mt-4">End Time</div>
            )}
            <input
              className={`${disabled && "opacity-50"} ${
                requiredBorder ? requiredBorder : "border border-gray-300"
              } bg-clip-padding block w-full 
            px-1 py-1 text-xs sm:text-xs rounded-sm`}
              {...register(props.endtime, validation)}
              disabled={disabled}
              onChange={endTimeonChange}
              type={type}
              {...props}
            />
          </div>
          <div>
            {props.dayopen === "mondayOpen" && (
              <div className="text-center -mt-4">Status</div>
            )}
            <select
              {...register(name, {})}
              className="border block w-full text-login bg-white bg-clip-padding leading-normal outline-none 
              px-1 py-1 text-xs sm:text-xs border-gray-300 rounded-sm"
              disabled={disabledStatus}
              onChange={selectOnChange}
            >
              <option key={1} value={"Open"} label="Open" />
              <option key={0} value={"Closed"} label="Closed" />
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};
export default TimeInputOfficeHrs;
